<template>
  <li :class="['mobile-account', { active }]">
    <a href="/account/promotions" class="link" v-if="LOGGED_IN">
      <f-sprite-icon :icon-link="$options.icons.IconNotifications.id" />
      Уведомления
      <ui-badge
        :text="PROMOS_COUNT"
        color="#F34744"
      />
    </a>
    <span class="link" @click="accountClick">
      <f-sprite-icon :icon-link="$options.icons.IconUser.id" />
      {{ title }}
      <ui-badge
        v-if="LOGGED_IN"
        :text="bonuses"
        color="#95D4E9"
      />
    </span>
    <div class="tree-menu depth2">
      <vue-client-only>
        <mobile-menu-header
          :title="title"
          show-back
          @back.stop="$f.showNav()"
        />
      </vue-client-only>

      <div class="mobile-account-container">
        <a href="/account" class="link">Профиль <span>{{ ACCOUNT.firstName }}</span></a>
        <a href="/account/orders" class="link">Заказы</a>
        <a href="/account/addresses" class="link">Адреса</a>
        <a href="/account/favorites" class="link">Избранное<ui-badge :text="favoritiesCount" size="large" color="#f34744" /></a>
        <a href="/account/subscribes" class="link">Подписки</a>
        <a href="/account/club" class="link">Клубная программа<ui-badge :text="bonuses" size="large" color="#95D4E9" /></a>
        <a href="/account/logout" class="link">Выход<f-sprite-icon :icon-link="$options.icons.IconExit.id" /></a>
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';
import VueClientOnly from 'vue-client-only';

/* Icons */
import IconUser from '../../assets/icons/user.svg';
import IconNotifications from '../../assets/icons/notifications.svg';
import IconExit from '../../assets/icons/exit.svg';

import MobileMenuHeader from './mobile-menu-header.vue';


export default {
  name: 'mobile-account',

  components: {
    MobileMenuHeader,
    VueClientOnly,
  },

  icons: {
    IconUser,
    IconNotifications,
    IconExit,
  },

  computed: {
    ...mapGetters({
      LOGGED_IN: 'user/loggedIn',
      ACCOUNT: 'user/account',
      BONUSES: 'user/bonuses',
      PROMOS_COUNT: 'user/promosCount',
      FAVORITIES_COUNT: 'favorites/favoritesShortCount',
    }),
    active() {
      return this.$f.navSection === 'account';
    },
    title() {
      return this.LOGGED_IN ? 'Личный кабинет' : 'Войти или зарегистрироваться';
    },
    bonuses() {
      return `${this.$options.filters.price(this.BONUSES)}`;
    },
    favoritiesCount() {
      return `${this.$options.filters.price(this.FAVORITIES_COUNT)}`;
    },
  },
  methods: {
    accountClick() {
      !this.LOGGED_IN && this.$f.hideNav();
      this.$f.login().then(() => {
        this.$f.showNav('account');
      }).catch(() => {
        this.$f.showNav();
      });
    }
  },
}
</script>

<style lang="scss">
.mobile-account {
  &-container {
    padding: $containerGapMobile 0;
    .link {
      span,
      .sprite-icon {
        font-weight: normal;
        margin: 0 0 0 auto;
        color: $gray;
      }
    }
  }
}
</style>
